<template>
  <router-view/>
</template>

<script>
import { useEcommerceStore } from './stores/Ecommerce';

export default {
  data() {
    return {
      cartClickHandler: null
    };
  },

  mounted() {
    this.cartClickHandler = (e) => {
      const btn = e.target.closest('button');
      if (!btn) return;
      const text = btn.textContent.trim().toLowerCase();
      if (!text.includes('add to cart')) return;

      const store = useEcommerceStore();

      // ── Find the closest product container ──────────────────────────────
      const container =
        btn.closest('.flex.flex-col.sm\\:flex-row') ||
        btn.closest('.bg-white') ||
        btn.closest('div[class*="border-b"]') ||
        btn.parentElement?.parentElement?.parentElement;

      // ── Extract image ────────────────────────────────────────────────────
      let image = '';
      if (container) {
        const img = container.querySelector('img');
        if (img) image = img.src;
      }
      if (!image) {
        const allImgs = document.querySelectorAll('img');
        if (allImgs.length) image = allImgs[0].src;
      }

      // ── Extract name ─────────────────────────────────────────────────────
      let name = '';
      if (container) {
        const nameEl =
          container.querySelector('.text-sm.font-semibold') ||
          container.querySelector('h2') ||
          container.querySelector('h1') ||
          container.querySelector('p');
        if (nameEl) name = nameEl.textContent.trim().slice(0, 80);
      }
      if (!name) name = 'Product Item';

      // ── Extract price ────────────────────────────────────────────────────
      let price = 0;
      if (container) {
        // Try regular $X.XX format first
        const priceEl = container.querySelector('[class*="text-black"]') ||
          container.querySelector('[class*="amber"]') ||
          container.querySelector('[class*="green"]');

        const rawText = priceEl ? priceEl.textContent : container.textContent;

        // Match patterns: $24.00 or $33.99
        const priceMatch = rawText.match(/\$\s*([\d,]+(?:\.\d{1,2})?)/);
        if (priceMatch) {
          price = parseFloat(priceMatch[1].replace(',', ''));
        }

        // Fallback: sup-style like $33 <sup>12</sup>
        if (!price) {
          const sups = container.querySelectorAll('sup');
          if (sups.length >= 2) {
            const dollars = sups[0].previousSibling?.textContent?.trim() || '0';
            const cents = sups[1].textContent?.trim() || '00';
            price = parseFloat(`${dollars}.${cents}`);
          }
        }
      }

      store.addToCartItem({ name, image, price: price || 24.00 });

      // ── Visual feedback on button ────────────────────────────────────────
      const origText = btn.textContent;
      btn.textContent = '✓ Added!';
      btn.style.backgroundColor = '#22c55e';
      btn.style.color = '#fff';
      btn.disabled = true;
      setTimeout(() => {
        btn.textContent = origText;
        btn.style.backgroundColor = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 1200);
    };

    document.addEventListener('click', this.cartClickHandler);
  },

  beforeUnmount() {
    if (this.cartClickHandler) {
      document.removeEventListener('click', this.cartClickHandler);
    }
  }
};
</script>

<style>
</style>
